import styled, { keyframes } from 'styled-components';
import { theme } from '../../../styles/theme';

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const float = keyframes`
  0% { transform: translateY(0px); }
  50% { transform: translateY(-10px); }
  100% { transform: translateY(0px); }
`;

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: #0d0d0d;
  z-index: 999999;
  display: flex;
  justify-content: center;
  align-items: center;
  animation: ${fadeIn} 0.8s ease-out forwards;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: radial-gradient(circle at center, rgba(255, 45, 85, 0.15) 0%, transparent 70%);
    pointer-events: none;
  }
`;

export const ContentContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  max-width: 1200px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 2rem;
  text-align: center;
`;

export const BackgroundImage = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: 0.6;
  filter: blur(4px);
  z-index: -1;
`;

export const GlassCard = styled.div`
  background: rgba(255, 255, 255, 0.03);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 40px;
  padding: 4rem 3rem;
  max-width: 600px;
  width: 90%;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5);
  animation: ${float} 6s ease-in-out infinite;

  @media (max-width: ${theme.breakpoints.mobile}) {
    padding: 3rem 1.5rem;
  }
`;

export const LogoWrapper = styled.div`
  margin-bottom: 2rem;
  
  svg {
    width: 80px;
    height: 80px;
    filter: drop-shadow(0 0 10px rgba(255, 45, 85, 0.5));
  }
`;

export const Title = styled.h1`
  font-family: 'Playfair Display', serif;
  font-size: 2.5rem;
  color: #fff;
  margin-bottom: 1.5rem;
  letter-spacing: -0.02em;
  background: linear-gradient(to bottom, #ffffff 0%, #a1a1a1 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;

  @media (max-width: ${theme.breakpoints.mobile}) {
    font-size: 2rem;
  }
`;

export const Description = styled.p`
  font-size: 1.1rem;
  color: rgba(255, 255, 255, 0.7);
  line-height: 1.6;
  margin-bottom: 2.5rem;
  max-width: 450px;
`;

export const StatusBadge = styled.div`
  background: rgba(255, 45, 85, 0.1);
  color: #ff2d55;
  padding: 0.5rem 1.25rem;
  border-radius: 100px;
  font-size: 0.875rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  border: 1px solid rgba(255, 45, 85, 0.2);
  margin-bottom: 2rem;
`;

export const Footer = styled.div`
  position: absolute;
  bottom: 2rem;
  color: rgba(255, 255, 255, 0.4);
  font-size: 0.875rem;
  letter-spacing: 0.05em;
`;
